<template>
  <div>
    <div v-if="canList">
      <listagem 
        :headers="headers" 
        :permission="permission" 
        :data="items"
        :font-size="fontSize"
      />
    </div>
    <div v-else-if="!canList">
      <div class="permission-denied" :style="{ fontSize: fontSize + 'px' }">
      <span class="red--text"
      >Você não tem permissão para visualizar as informações desta tela</span
      >
    </div>
  </div>
  </div>
</template>

<script>
import Listagem from './listagem/Componente'
import { BasicPermissions, Sequences } from '@/utils/permissions'
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    headers: {
      type: Array,
    },
    fontSize: {
      type: Number,
      default: 14,
    },
  },
  components: {
    Listagem,
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions('template', ['successMessage', 'errorMessage']),
    increaseFontSize() {
      if (this.fontSize < this.maxFontSize) {
        this.fontSize++
      }
    },
    decreaseFontSize() {
      if (this.fontSize > this.minFontSize) {
        this.fontSize--
      }
    },
    getTempo(item) {
      const diferencaEmMs = new Date() - Date.parse(item)
      const segundos = diferencaEmMs / 1000
      return segundos
    },
  },
  computed: {
    ...mapState('auth', ['user', 'empresaAtual']),
    ...mapState('supervisorio', ['gates']),
    items() {
      return this.gates
    },
    permission() {
      return Sequences.GerenciamentoServico.toString()
    },
    canList() {
      return this.$canDo(BasicPermissions.VISUALIZAR, this.permission)
    },
  },
  async created() {},
}
</script>
